export const formatSSN = (ssn: string) => {
    const cleanedSSN = ssn.replace(/[^\d]/g, '');

    const formattedSSN = cleanedSSN.substring(0, 3) + '-' +
                         cleanedSSN.substring(3, 5) + '-' +
                         cleanedSSN.substring(5);

    return formattedSSN;
}